import { CloseOutlined, PlayCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import ProxyVideo from './ProxyVideo';
import { useEffect, useState } from 'react';
import { css } from '@emotion/css';
import { getVideoThumbUrl } from 'utils/validator/video';
import { noop } from 'lodash-es';

interface VideoPreviewProps {
  thumbUrl?: string;
  thumbWidth: number;
  thumbHeight: number;
  videoUrl: string;
}

export const VideoPreview = (props: VideoPreviewProps) => {
  const { thumbUrl, thumbWidth, thumbHeight, videoUrl } = props;
  const [open, setOpen] = useState(false);

  const [renderThumbUrl, setRenderThumbUrl] = useState(thumbUrl);

  useEffect(() => {
    if (thumbUrl) {
      setRenderThumbUrl(thumbUrl);
      return;
    }

    getVideoThumbUrl(videoUrl).then(setRenderThumbUrl).catch(noop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        className="relative cursor-pointer hover:opacity-80 transition-opacity duration-300"
        style={{ width: thumbWidth, height: thumbHeight }}
        onClick={() => setOpen(true)}
      >
        <span className="absolute z-[1] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <PlayCircleFilled />
        </span>
        <img
          className="w-full h-full object-cover bg-[#000000] opacity-70"
          src={renderThumbUrl}
          alt={renderThumbUrl}
        />
      </div>

      <Modal
        width={800}
        centered
        wrapClassName={wrapperClassName}
        destroyOnClose
        footer={null}
        visible={open}
        onCancel={() => setOpen(false)}
        closable={false}
        title={
          <div
            className="flex items-center justify-end h-[24px] text-[#FFFFFF] cursor-pointer"
            onClick={() => setOpen(false)}
          >
            <CloseOutlined />
          </div>
        }
      >
        {open && (
          <ProxyVideo
            className="w-full h-[calc(100vh-200px)] object-contain bg-[#000000]"
            controls
            autoPlay
            src={videoUrl}
            controlsList="nodownload"
          >
            <track kind="captions" />
          </ProxyVideo>
        )}
      </Modal>
    </>
  );
};

const wrapperClassName = css`
  .ant-modal-header {
    padding: 4px 16px;
    background-color: rgba(0, 0, 0, 0.7);
    border: none;
  }
  .ant-modal-content {
    background-color: transparent;
    box-shadow: none;
  }
  .ant-modal-body {
    padding: 0;
  }
`;
